import { render, staticRenderFns } from "./power.vue?vue&type=template&id=6fb1344a&scoped=true&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"
import style0 from "./power.vue?vue&type=style&index=0&id=6fb1344a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1344a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb1344a')) {
      api.createRecord('6fb1344a', component.options)
    } else {
      api.reload('6fb1344a', component.options)
    }
    module.hot.accept("./power.vue?vue&type=template&id=6fb1344a&scoped=true&", function () {
      api.rerender('6fb1344a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/power.vue"
export default component.exports